import * as THREE from 'three';

export function createFogOfWarMesh(game, config) {
  const {
    outerRadius,
    innerRadius,
    feather,
    opacity,
  } = config;
  const geo = new THREE.CircleGeometry(outerRadius, 96);
  const mat = new THREE.ShaderMaterial({
    transparent: true,
    depthWrite: false,
    side: THREE.DoubleSide,
    uniforms: {
      uInnerRadius: { value: innerRadius },
      uOuterRadius: { value: innerRadius + feather },
      uMaxOpacity: { value: opacity },
    },
    vertexShader: `
      varying vec2 vLocal;
      void main() {
        vLocal = position.xy;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `,
    fragmentShader: `
      uniform float uInnerRadius;
      uniform float uOuterRadius;
      uniform float uMaxOpacity;
      varying vec2 vLocal;

      void main() {
        float dist = length(vLocal);
        float alpha = smoothstep(uInnerRadius, uOuterRadius, dist) * uMaxOpacity;
        gl_FragColor = vec4(vec3(0.0), alpha);
      }
    `,
  });
  const mesh = new THREE.Mesh(geo, mat);
  mesh.rotation.x = -Math.PI / 2;
  mesh.position.set(0, 2.8, 0);
  mesh.renderOrder = 999;
  mesh.visible = false;
  game.scene.add(mesh);
  return mesh;
}

export function roomSeedFor(game, roomNum) {
  return ((game._sessionSeed ^ ((roomNum * 2654435761) >>> 0)) >>> 0);
}

export function syncSlashFxDebug(game) {
  game.slashFx.setDebugConfig(game._slashFxDebug);
}

export function ensureHitFlash(game) {
  game._hitFlashEl = document.createElement('div');
  game._hitFlashEl.className = 'hit-flash';
  document.getElementById('app').appendChild(game._hitFlashEl);
}
